import React from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Dialog,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";

import { getLocationFullName } from "../../../utils/locationUtils";
import { getUnitName } from "../../../utils/loadTypeUtils";

export const InventoriesDialog = ({
  currentInventory,
  showInventories,
  setShowInventories,
  isSmall,
  selectedLocation,
  locationInventories,
  isShipmentInventoryItem,
}) => {
  const getLocationProductName = () => {
    if (selectedLocation?.productId) {
      const locationInventory = locationInventories.find(
        (itm) => itm.id === selectedLocation.productId,
      );
      if (locationInventory) {
        return (
          <Box mb={2} mt={0} ml={2}>
            <Typography color="textSecondary" variant="subtitle2">
              Reserved for {locationInventory.productName}
            </Typography>
          </Box>
        );
      }
    }
    return null;
  };

  return (
    <Dialog
      open={showInventories}
      onClose={() => setShowInventories(false)}
      fullWidth={true}
      fullScreen={isSmall}
      maxWidth="md"
    >
      <Box
        component="span"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        m={2}
        mb={0}
      >
        <Typography variant="h6">
          {`${getLocationFullName(selectedLocation)} inventories`}
        </Typography>
        <CancelOutlinedIcon
          fontSize="large"
          onClick={() => setShowInventories(false)}
        />
      </Box>
      {getLocationProductName()}
      <Box mb={1}></Box>
      <DialogContent>
        {locationInventories.length > 0 && (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell>Account</TableCell>
                  <TableCell>{isSmall ? "Onhd" : "Quantity Onhand"}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {locationInventories.map((itm) => (
                  <TableRow key={itm.id}>
                    <TableCell>
                      <Box display="flex" alignItems="center" component="span">
                        {isShipmentInventoryItem(itm) ? (
                          <CheckIcon
                            style={{ marginRight: 4, color: green[500] }}
                            fontSize="small"
                          />
                        ) : (
                          <CloseIcon
                            style={{ marginRight: 4 }}
                            fontSize="small"
                          />
                        )}
                        {itm.inventory.productName}
                      </Box>
                    </TableCell>
                    <TableCell>{itm.inventory.accountName}</TableCell>
                    <TableCell>{`${itm.quantityOnHand} ${
                      isSmall ? "" : getUnitName(currentInventory.inventoryUOM)
                    }`}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowInventories(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
